import * as React from "react";
import type { PageHeaderProps } from "../../components/PageHeader/PageHeader.web.data";
import type { SiteSetting } from "../../types";
import { Layout } from "../Layout.web";
import {
  PromptsPageContent,
  type PromptsPageContentProps,
} from "./PromptsPageContent.web";

export type PromptsContainerProps = PromptsPageContentProps & {
  header: PageHeaderProps;
  setting: SiteSetting;
};

export const PromptsContainer: React.FC<PromptsContainerProps> = (props) => {
  return (
    <Layout
      header={props.header}
      setting={{ ...props.setting, showManageAccess: true }}
    >
      <PromptsPageContent {...props} />
    </Layout>
  );
};
